// src/pages/portal/PortalNuevaConversacionPage.tsx
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCrearPortalConversacion, usePortalEmpresas } from '@/hooks/queries';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Button,
  Input,
  Textarea,
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
  Label,
} from '@/components/ui';
import { ArrowLeft, MessageSquare } from 'lucide-react';

export default function PortalNuevaConversacionPage() {
  const navigate = useNavigate();
  const { data: empresas } = usePortalEmpresas();
  const crearConversacion = useCrearPortalConversacion();

  const [formData, setFormData] = useState({
    asunto: '',
    mensaje_inicial: '',
    empresa_id: '',
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    crearConversacion.mutate(
      {
        asunto: formData.asunto || undefined,
        mensaje_inicial: formData.mensaje_inicial,
        empresa_id: formData.empresa_id || undefined,
      },
      {
        onSuccess: (conversacion) => {
          navigate(`/portal/conversaciones/${conversacion.id}`);
        },
      }
    );
  };

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      {/* Header */}
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="sm" onClick={() => navigate('/portal/conversaciones')}>
          <ArrowLeft className="w-4 h-4 mr-2" />
          Volver
        </Button>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <MessageSquare className="w-5 h-5" />
            Nueva Conversacion
          </CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Asunto */}
            <div>
              <Label htmlFor="asunto">Asunto (opcional)</Label>
              <Input
                id="asunto"
                value={formData.asunto}
                onChange={(e) =>
                  setFormData({ ...formData, asunto: e.target.value })
                }
                placeholder="Describe brevemente el tema"
              />
            </div>

            {/* Empresa (si tiene varias) */}
            {empresas && empresas.length > 1 && (
              <div>
                <Label htmlFor="empresa">Empresa</Label>
                <Select
                  value={formData.empresa_id}
                  onValueChange={(value) => setFormData({ ...formData, empresa_id: value })}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Selecciona una empresa" />
                  </SelectTrigger>
                  <SelectContent>
                    {empresas.map((e) => (
                      <SelectItem key={e.id} value={e.id}>{e.nombre}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            )}

            {/* Mensaje inicial */}
            <div>
              <Label htmlFor="mensaje">Mensaje *</Label>
              <Textarea
                id="mensaje"
                value={formData.mensaje_inicial}
                onChange={(e) =>
                  setFormData({ ...formData, mensaje_inicial: e.target.value })
                }
                placeholder="Escribe tu mensaje..."
                rows={6}
                required
              />
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                Describe tu consulta o problema con el mayor detalle posible.
              </p>
            </div>

            {/* Botones */}
            <div className="flex justify-end gap-3 pt-4">
              <Button variant="outline" type="button" asChild>
                <Link to="/portal/conversaciones">Cancelar</Link>
              </Button>
              <Button type="submit" disabled={crearConversacion.isPending}>
                {crearConversacion.isPending ? 'Enviando...' : 'Iniciar Conversacion'}
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
